module.exports = __webpack_public_path__ + "img/bg-working-guy.8f68edd5.svg";